import { createRouteRef, createApiRef } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';

const azurePullRequestDashboardRouteRef = createRouteRef({
  id: "azure-pull-request-dashboard"
});
const azurePipelinesEntityContentRouteRef = createRouteRef({
  id: "azure-pipelines-entity-content"
});
const azureGitTagsEntityContentRouteRef = createRouteRef({
  id: "azure-git-tags-entity-content"
});
const azurePullRequestsEntityContentRouteRef = createRouteRef({
  id: "azure-pull-requests-entity-content"
});

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AzureDevOpsClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "fetchApi");
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }
  async getRepoBuilds(projectName, repoName, host, org, options) {
    const queryString = new URLSearchParams();
    if (options == null ? void 0 : options.top) {
      queryString.append("top", options.top.toString());
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    const urlSegment = `repo-builds/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getGitTags(projectName, repoName, entityRef, host, org) {
    const queryString = new URLSearchParams();
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    queryString.append("entityRef", entityRef);
    const urlSegment = `git-tags/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getPullRequests(projectName, repoName, entityRef, host, org, options) {
    const queryString = new URLSearchParams();
    if (options == null ? void 0 : options.top) {
      queryString.append("top", options.top.toString());
    }
    if (options == null ? void 0 : options.status) {
      queryString.append("status", options.status.toString());
    }
    if (options == null ? void 0 : options.teamsLimit) {
      queryString.append("teamsLimit", options.teamsLimit.toString());
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    queryString.append("entityRef", entityRef);
    const urlSegment = `pull-requests/${encodeURIComponent(
      projectName
    )}/${encodeURIComponent(repoName)}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  getDashboardPullRequests(projectName, teamsLimit) {
    const queryString = new URLSearchParams();
    queryString.append("top", "100");
    if (teamsLimit) {
      queryString.append("teamsLimit", teamsLimit.toString());
    }
    const urlSegment = `dashboard-pull-requests/${projectName}?${queryString}`;
    return this.get(urlSegment);
  }
  getAllTeams(limit) {
    const queryString = new URLSearchParams();
    if (limit) {
      queryString.append("limit", limit.toString());
    }
    let urlSegment = "all-teams";
    if (queryString.toString()) {
      urlSegment += `?${queryString}`;
    }
    return this.get(urlSegment);
  }
  getUserTeamIds(userId) {
    return this.get(`users/${userId}/team-ids`);
  }
  async getBuildRuns(projectName, entityRef, repoName, definitionName, host, org, options) {
    const queryString = new URLSearchParams();
    if (repoName) {
      queryString.append("repoName", repoName);
    }
    if (host) {
      queryString.append("host", host);
    }
    if (org) {
      queryString.append("org", org);
    }
    if (definitionName) {
      const definitionNames = definitionName.split(",");
      if (definitionNames.length > 1) {
        const buildRuns = [];
        for (const name of definitionNames) {
          queryString.set("definitionName", name.trim());
          if (options == null ? void 0 : options.top) {
            queryString.set("top", options.top.toString());
          }
          queryString.append("entityRef", entityRef);
          const urlSegment2 = `builds/${encodeURIComponent(
            projectName
          )}?${queryString}`;
          const items2 = await this.get(urlSegment2);
          buildRuns.push(...items2);
        }
        return { items: buildRuns };
      }
      queryString.append("definitionName", definitionName.trim());
    }
    if (options == null ? void 0 : options.top) {
      queryString.append("top", options.top.toString());
    }
    queryString.append("entityRef", entityRef);
    const urlSegment = `builds/${encodeURIComponent(
      projectName
    )}?${queryString}`;
    const items = await this.get(urlSegment);
    return { items };
  }
  async getReadme(opts) {
    const queryString = new URLSearchParams();
    if (opts.host) {
      queryString.append("host", opts.host);
    }
    if (opts.org) {
      queryString.append("org", opts.org);
    }
    if (opts.path) {
      queryString.append("path", opts.path);
    }
    queryString.append("entityRef", opts.entityRef);
    return await this.get(
      `readme/${encodeURIComponent(opts.project)}/${encodeURIComponent(
        opts.repo
      )}?${queryString}`
    );
  }
  async get(path) {
    const baseUrl = `${await this.discoveryApi.getBaseUrl("azure-devops")}/`;
    const url = new URL(path, baseUrl);
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

const azureDevOpsApiRef = createApiRef({
  id: "plugin.azure-devops.service"
});

export { AzureDevOpsClient as A, azureDevOpsApiRef as a, azurePullRequestDashboardRouteRef as b, azurePipelinesEntityContentRouteRef as c, azureGitTagsEntityContentRouteRef as d, azurePullRequestsEntityContentRouteRef as e };
//# sourceMappingURL=AzureDevOpsApi-GBxs-uQ7.esm.js.map
